import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export const EmailSentSchema = Type.Object(
  {
    winner: Type.Boolean(),
  },
  { additionalProperties: false, $id: 'EmailSentSchema' }
);

export const SkillTestSchema = Type.Object({
  question: Type.String(),
  answer: Type.Number(),
});

export type LotteryDraw = Static<typeof LotteryDrawSchema>;
export const LotteryDrawSchema = Type.Object(
  {
    createdAt: Type.String({ format: 'date-time' }),
    endDate: Type.String({ format: 'date-time' }),
    id: Type.String(),
    nbrParticipants: Type.Integer({ minimum: 0 }),
    nbrWinners: Type.Integer({ minimum: 0 }),
    startDate: Type.String({ format: 'date-time' }),
    updatedAt: Type.String({ format: 'date-time' }),
    skillTest: SkillTestSchema,
  },
  { additionalProperties: false, $id: 'LotteryDrawSchema' }
);
